'use client';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import type { ReactNode } from 'react';

/**
 * `nonce` forwards the per-request CSP nonce (from proxy.ts middleware) to the
 * inline theme-detection <script> that next-themes injects pre-paint. Without
 * it the script is blocked by our strict-dynamic CSP, the browser logs the
 * sha256 of the blocked source as a hint, and theme-flash-on-load returns.
 * Read from `headers().get('x-nonce')` in the server-component layout that
 * mounts this provider.
 */
export function ThemeProvider({ children, nonce }: { children: ReactNode; nonce?: string }) {
  return (
    <NextThemesProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange nonce={nonce}>
      {children}
    </NextThemesProvider>
  );
}
